module.exports = __webpack_public_path__ + "static/img/gui-img-04@w.dce9ba2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/genesis-shop/gui-img-04@w.png
// module id = CM07
// module chunks = 0